export const listRooms = rooms => {
  const roomsQuantity = {};
  rooms.forEach(room => {
    if (roomsQuantity[room.description]) {
      roomsQuantity[room.description].quantity += 1;
    } else {
      roomsQuantity[room.description] = {
        name: room.description,
        quantity: 1,
      };
    }
  });
  return Object.values(roomsQuantity);
};
